import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "card pb-2" }
const _hoisted_2 = { class: "m-0 p-0 list-none flex flex-wrap gap-2" }
const _hoisted_3 = { class: "ml-1" }

import Panel from 'primevue/panel';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import { computed } from 'vue';
import Button from 'primevue/button';
import { LinkItem } from '@/utils/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalculationViewLink',
  props: {
    links: { default: () => [] }
  },
  setup(__props: any) {

/* eslint-env vue/setup-compiler-macros */
const props = __props;

const typeLabelMap: Record<string, string> = {
  material: 'Materiały',
  presentation: 'Prezentacje',
  calculator: 'Kalkulatory',
};

const tabs = computed(() => {
  const groups = new Map<string, { title: string; value: string }>();
  for (const link of props.links) {
    const type = (link.type ?? 'inne').toString();
    if (!groups.has(type)) {
      const title = typeLabelMap[type] ?? type.charAt(0).toUpperCase() + type.slice(1);
      groups.set(type, { title, value: type });
    }
  }
  return Array.from(groups.values());
});

const linksByType = computed(() => {
  const map: Record<string, LinkItem[]> = {};
  for (const link of props.links) {
    const type = (link.type ?? 'inne').toString();
    if (!map[type]) map[type] = [];
    map[type].push(link);
  }
  return map;
});

function onOpen(link: LinkItem) {
  if (!link?.url) return;
  if (link.open_in_new_tab) {
    window.open(link.url, '_blank', 'noopener');
  } else {
    window.location.href = link.url;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Panel), {
      header: "Linki i materiały",
      toggleable: "",
      collapsed: true
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Tabs), {
          value: tabs.value[0]?.value ?? ''
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TabList), null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
                  return (_openBlock(), _createBlock(_unref(Tab), {
                    key: tab.value,
                    value: tab.value,
                    class: "text-sm font-semibold"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tab.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_unref(TabPanels), { class: "p-0" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
                  return (_openBlock(), _createBlock(_unref(TabPanel), {
                    key: tab.value,
                    value: tab.value
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("ul", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(linksByType.value[tab.value], (link) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: link.id,
                            class: "flex items-center gap-2"
                          }, [
                            _createVNode(_unref(Button), {
                              class: "font-semibold bg-white",
                              severity: "secondary",
                              outlined: "",
                              size: "small",
                              onClick: ($event: any) => (onOpen(link))
                            }, {
                              default: _withCtx(() => [
                                (link.icon)
                                  ? (_openBlock(), _createElementBlock("i", {
                                      key: 0,
                                      class: _normalizeClass(`pi ${link.icon}`),
                                      "aria-hidden": "true"
                                    }, null, 2))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", _hoisted_3, _toDisplayString(link.title), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _: 1
    })
  ]))
}
}

})